import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 256 256"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("desc", null, "Circle Notch Streamline Icon: https://streamlinehq.com", -1),
    _createElementVNode("path", { d: "M253.44 123.177c0 96.564-104.533 156.916-188.16 108.634-38.811-22.408-62.72-63.819-62.72-108.634 0-49.452 28.719-94.514 73.165-114.91 6.75-3.102 14.327 2.267 13.637 9.664a9.65 9.65 0 0 1-5.58 7.873c-37.62 17.272-61.924 55.483-61.924 97.373 0 81.708 88.452 132.775 159.213 91.921 32.84-18.96 53.07-54 53.07-91.921 0-41.89-24.303-80.1-61.923-97.373-6.75-3.101-7.612-12.347-1.551-16.642a9.65 9.65 0 0 1 9.608-.895c44.447 20.396 73.165 65.458 73.165 114.91" }, null, -1)
  ]))]))
}
export default { render: render }